export interface PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorJSON {
  pprjdci_id: string | null;
  pprjdci_fedid: string;
  pprjdci_catid: number;
  pprjdci_equipo_orden: string;
  pprjdci_catinfid: string;
  pprjdci_cant_permitida: string;
  pprjdci_orden_equipo_a_incluir_desde: string;
  __delete: boolean;
}

export class PlanillaPartidoReglaJugadorDisponibleCategoriasInferior {
  protected constructor(
    private pprjdci_id: string | null,
    private pprjdci_fedid: string,
    private pprjdci_catid: number,
    private pprjdci_equipo_orden: string,
    private pprjdci_catinfid: string,
    private pprjdci_cant_permitida: string,
    private pprjdci_orden_equipo_a_incluir_desde: string,
    private __delete: boolean
  ) {}

  static createFrom(
    pprjdci_id: string | null,
    pprjdci_fedid: string,
    pprjdci_catid: number,
    pprjdci_equipo_orden: string,
    pprjdci_catinfid: string,
    pprjdci_cant_permitida: string,
    pprjdci_orden_equipo_a_incluir_desde: string,
    __delete: boolean
  ) {
    return new this(
      pprjdci_id,
      pprjdci_fedid,
      pprjdci_catid,
      pprjdci_equipo_orden,
      pprjdci_catinfid,
      pprjdci_cant_permitida,
      pprjdci_orden_equipo_a_incluir_desde,
      __delete
    );
  }

  static createForPlanilla(
    catid: number,
    equipo_orden: string,
    catinfid: string,
    cant_permitida: string,
    orden_equipo_a_incluir_desde: string,
    __delete: boolean
  ) {
    return PlanillaPartidoReglaJugadorDisponibleCategoriasInferior.createFrom(
      null,
      '',
      catid,
      equipo_orden,
      catinfid,
      cant_permitida,
      orden_equipo_a_incluir_desde,
      __delete
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.pprjdci_id === anId;
  }

  isIdentifiedAs(aEntity: PlanillaPartidoReglaJugadorDisponibleCategoriasInferior) {
    if (this.pprjdci_id) {
      return aEntity.isIdentifiedBy(this.pprjdci_id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorJSON) {
    return PlanillaPartidoReglaJugadorDisponibleCategoriasInferior.createFrom(
      entity.pprjdci_id,
      entity.pprjdci_fedid,
      entity.pprjdci_catid,
      entity.pprjdci_equipo_orden,
      entity.pprjdci_catinfid,
      entity.pprjdci_cant_permitida,
      entity.pprjdci_orden_equipo_a_incluir_desde,
      entity.__delete
    );
  }

  toJSON(): PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorJSON {
    return {
      pprjdci_id: this.getId(),
      pprjdci_fedid: this.getFedid(),
      pprjdci_catid: this.getCatid(),
      pprjdci_equipo_orden: this.getEquipoOrden(),
      pprjdci_catinfid: this.getCatinfid(),
      pprjdci_cant_permitida: this.getCantPermitida(),
      pprjdci_orden_equipo_a_incluir_desde: this.getOrdenEquipoAIncluirDesde(),
      __delete: this.__delete,
    };
  }

  isActive(): boolean {
    return !this.__delete;
  }

  getId(): string | null {
    return this.pprjdci_id;
  }

  getFedid(): string {
    return this.pprjdci_fedid;
  }

  getCatid(): number {
    return this.pprjdci_catid;
  }

  getEquipoOrden(): string {
    return this.pprjdci_equipo_orden;
  }

  getCatinfid(): string {
    return this.pprjdci_catinfid;
  }

  getCantPermitida(): string {
    return this.pprjdci_cant_permitida;
  }

  getOrdenEquipoAIncluirDesde(): string {
    return this.pprjdci_orden_equipo_a_incluir_desde;
  }

  setId(value: string | null): void {
    this.pprjdci_id = value;
  }

  setFedid(value: string): void {
    this.pprjdci_fedid = value;
  }

  setCatid(value: number): void {
    this.pprjdci_catid = value;
  }

  setEquipoOrden(value: string): void {
    this.pprjdci_equipo_orden = value;
  }

  setCatinfid(value: string): void {
    this.pprjdci_catinfid = value;
  }

  setCantPermitida(value: string): void {
    this.pprjdci_cant_permitida = value;
  }

  setOrdenEquipoAIncluirDesde(value: string): void {
    this.pprjdci_orden_equipo_a_incluir_desde = value;
  }

  setDeleted(d: boolean) {
    this.__delete = d;
  }
}
